export default "__VITE_ASSET__f6487526__"